<template>
  <the-new-header></the-new-header>

  <section class="web-section">
    <base-info-bar>
      <router-link to="/site-map" style="color: black;">{{ getMenuInfo.name}}</router-link>
    </base-info-bar>

    <WebsiteStructure :title="getMenuInfo.name"></WebsiteStructure>
  </section>

  <the-footer></the-footer>
</template>

<script>
import WebsiteStructure from '../../components/web-structure-page/WebsiteStructure.vue'
export default {
  components: {
    WebsiteStructure
  },
  computed: {
    getMenuInfo () {
      return this.$store.getters['navbar/finalMenu']?.[5] || null
    }
  }
}
</script>

<style scoped>
.web-section {
  padding: 0 170px;
  min-height: 525px;
}

.web-section a {
  text-decoration: none;
  color: rgb(28, 108, 193);
  font-weight: 700;
}

.web-section span{
  font-weight: 800;
}

  @media (max-width: 1356px) {
    .web-section {
      padding: 0 100px;
    }
  }

  @media (max-width: 1080px) {
    .web-section {
      padding: 0 50px;
    }
  }

  @media (max-width: 720px) {
    .web-section {
      padding: 0px 20px;
    }
  }
</style>
